import React, { Component } from "react"
import { connect } from "react-redux"
import Menu from "components/menu"
import config from "./config"

class WeightReview extends Component {
  render() {
    return <Menu {...config} {...this.props} />
  }
}

const mapStateToProps = state => {
  return {
    messages: state.intl.messages.containers.litterFeatures.weightReview,
    weightReview: state.reducers.weightReview
  }
}

export default connect(mapStateToProps)(WeightReview)
